// show Map Field list select data in Table(2700807425)
/*
Asharf   09/29/2022 2700799562 fixed bugs on global fields List
Poornima 09/29/2022 2785319522 delete usage popup changes
Sohel    09/30/2022 2700799562 Fixed Jira bugs
Sohel    09/30/2022 2700799562 Changed disabled Condition
Asharf   10/07/2022 2700799562 fixed bugs on global fields List
Sohel    10/14/2022 2700799562 Added Code Comments Changes
Suresh   10/17/2022 2700799562 Design Enhancements in global Field List
Suresh   10/25/2022 2700799562 Removed Hyphen mark in table data
saikrishna 11/03/2022 2700799562 changed the paginationOptions
Suresh Peddavoora 11/03/2022 2700799562 Added outlined Icons in Actions Column in Table.
Raghu 11/28/2022 2700799562 Table Footer Fixes
lalitha 11/29/2022 2700799562 Table column changed
Sohel 11/30/2022 2700430604  remove fields
Sohel 12/02/2022 2700799562 Global Field List Changes
Sohel 12/03/2022 3031450488 Global Field List deleted bugs and Column rearrange.
Sohel 12/03/2022 2700799562 Added delete disabled Condition
Poornima 12/07/2022 2700799562 delete popup text changes
Poornima 12/13/2022 2700799562 fieldname prepopulation done in delete popup
Lalitha 12/15/2022 2700799562 Added Role Base Access
Akhila 05/30/2023 2692790263 bug fixed unsaved changes
Ravi 05/31/2023 2700799562 changed delete popup message
Akhila 07/01/2023 2700799562 field list name change to audit field list
*/
import React, {useState} from 'react';
import {Grid, TablePagination} from '@material-ui/core';
import {tableIcons} from '../../../../../components/TableIcons';
import {defaultRows} from '../../../../../constants/ReusableTablePagination';
import {useSelector} from 'react-redux';
import DeleteTableRecordPopup from '../../../../../util/DeleteTableRecordPopup';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import {tablePageRows} from '../../../../../constants/ReusableConstants';

export default function AddFieldListTable({
  searchData,
  selectedRows,
  setSelectedRows,
  deletedIds,
  setDeletedIds,
  values,
  setFieldValue,
  fieldsDeleteIdsRef,
  fieldListCode,
  isCopyData,
  setDirtyRef,
}) {
  const {globalFieldListData} = useSelector(({addFieldList}) => addFieldList);
  const {roleData} = useSelector(({role}) => role);
  // const disableDelete = roleData?.window?.["Global Fields"]?.["GF"]?.delete;
  const disable = roleData?.window?.['Audit Field List']?.['FL'];

  const [isDelete, setIsDelete] = useState(false);
  const [deleteData, setDeleteData] = useState({});
  const columns = [
    {
      title: 'Category',
      // field: "category",
      render: (rowData) => {
        return rowData?.category === 'CL' ?
        `CL - Client` :
          rowData?.category === 'CO' ?
        `CO - Core` :
            '';
      },
      width: '1%',
    },
    {
      title: 'Repository Name',
      field: 'repositoryName',
    },
    {
      title: 'Field Name',
      field: 'fieldName',
    },

    {
      title: 'Field Type',
      field: 'fieldType',
    },
    {
      title: 'Repository Type',
      field: 'repositoryType',
    },
  ];

  const [rows, setRows] = useState(defaultRows);
  const handleDelete = (rowData) => {
    setDeleteData(rowData);
    setIsDelete(true);
  };
  const handleDeleteClose = () => {
    setIsDelete(false);
  };
  const handleSubmit = () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const arr = [...selectedRows];
        const newData = arr.filter(
          (row) =>
            row.fieldName.concat(row.repositoryName) !==
            deleteData?.fieldName.concat(deleteData?.repositoryName),
        );
        const newDeletedIds = [...deletedIds];
        if (deleteData?.fieldListFieldId) {
          newDeletedIds.push(deleteData?.fieldListFieldId);
        }
        fieldsDeleteIdsRef.current = [...fieldsDeleteIdsRef.current, ...newDeletedIds];
        // setDeletedIds(newDeletedIds);
        const otherCategory = newData?.filter((ele) => ele.category === deleteData?.category);
        if (otherCategory?.length === 0) {
          const filteredCatagory = values?.otherCategory?.filter(
            (el) => el !== deleteData?.category,
          );
          setFieldValue('otherCategory', filteredCatagory);
        }
        setSelectedRows(newData);
        handleDeleteClose();
        resolve();
      }, 1000);
      setDirtyRef(true);
    });
  };

  return (
    <>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleDeleteClose}
        title="Delete Field"
        value={`Are you sure you want to delete the ${deleteData?.fieldName} Field ?`}
        // value={`Are you sure you want to delete the ${deleteData?.fieldName} field from the ${
        //   fieldListCode ? fieldListCode : ""
        // } Field List?`}
        handleSubmit={handleSubmit}
      />
      <Grid item xs={12} className="">
        {}
        <div className="custom-table global-field-table tablescroll-block ">
          <GuiTable
            title=""
            columns={columns}
            icons={tableIcons}
            data={selectedRows}
            options={{
              toolbar: false,
              search: false,
              pageSize: rows,
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            actions={[
              (rowData) => {
                return {
                  icon: () => <DeleteOutlineOutlinedIcon />,
                  tooltip: 'Delete',
                  // disabled: Object.keys(fieldListData).length > 0 && !disableDelete,
                  disabled:
                    (rowData?.fieldListFieldId ?
                      Boolean(
                        (rowData.fieldName === 'ACCOUNT_NUMBER' &&
                            rowData.repositoryName === 'DB_ACCOUNT') ||
                            (rowData.fieldName === 'CLIENT_NUMBER' &&
                              rowData.repositoryName === 'DB_ACCOUNT'),
                      ) :
                      false) ||
                    (globalFieldListData?.fieldListCode && !isCopyData && disable?.edit === false),
                  // disabled:(disable?.edit === false),
                  onClick: (event, rowData) => {
                    handleDelete(rowData);
                  },
                };
              },
            ]}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer">
                  <TablePagination
                    {...props}
                    SelectProps={{
                      inputProps: {'aria-label': 'Rows per screen'},
                    }}
                    labelRowsPerPage={'Rows per screen:'}
                    rowsPerPageOptions={tablePageRows}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              ),
            }}
          />
        </div>
      </Grid>
    </>
  );
}
